import React from 'react';
import { icons } from 'feather-icons';
import { createIcon } from '@gluestack-ui/themed';
import * as FeatherIconsRN from 'react-native-feather';
import { filterObject } from '@tonic/central-specialties-utils';
import { toPascalCase, camelKeys } from 'js-convert-case';
/**
 * Programmatically convert React-Native-Feather icons to a format compatible
 * with the gluestack Icon component, so that theme can still be applied to them
 * seamlessly (color tokens, space, etc.)
 */
export const Icons = Object.keys(icons).reduce((acc, featherIconLabel) => {
    const kebabIconName = featherIconLabel;
    const IconName = toPascalCase(featherIconLabel);
    if (!(IconName in FeatherIconsRN)) {
        return acc;
    }
    const IconComponent = FeatherIconsRN[IconName];
    acc[IconName] = createIcon({
        ...camelKeys(filterObject(icons[kebabIconName].attrs, [
            'viewBox',
            'stroke-linecap',
            'stroke-linejoin',
        ])),
        path: (React.createElement(IconComponent, { ...filterObject(icons[kebabIconName].attrs, ['stroke', 'fill']) })),
    });
    return acc;
}, {});
